<template>
  <div class="integral-view">
    <p>{{ orderInfo.orderNo }}</p>
    <div class="view-main">
      <a-spin :spinning="loading">
        <div class="view-head">
          <div class="head-lef">
            <Nav label="动态" :is-class="false"></Nav>
            <a-steps
              progress-dot
              :current="0"
              :initial="0"
              direction="vertical"
            >
              <a-step
                v-for="(item,index) in timeLineList"
                :key="index"
                :title="item.title"
                :sub-title="item.userName"
                :description="item.createTime"
              />
            </a-steps>
          </div>
          <div class="head-rig">
            <Nav label="订单信息" :is-class="false"></Nav>
            <div class="rig-main">
              <div class="main-top">
                <div class="rig-item">
                  <p>订单编号：</p>
                  <p>{{ orderInfo.orderNo }}</p>
                </div>
                <div class="rig-item">
                  <p>取货点：</p>
                  <p>回收点</p>
                </div>
                <div class="rig-item">
                  <p>订单状态：</p>
                  <p class="color">
                    {{ orderInfo.state }}
                  </p>
                </div>
                <div class="rig-item">
                  <p>下单时间：</p>
                  <p>{{ orderInfo.createTime }}</p>
                </div>
                <div class="rig-item">
                  <p>配送方式：</p>
                  <p>回收点自取</p>
                </div>
                <div class="rig-item">
                  <p>取货时间：</p>
                  <p>{{ orderInfo.startTime }}</p>
                </div>
                <div class="rig-item">
                  <p>下单渠道：</p>
                  <p>{{ orderInfo.channel }}</p>
                </div>
                <div class="rig-item">
                  <p>取货人：</p>
                  <p>{{ orderInfo.userName }}</p>
                </div>
                <div class="rig-item">
                  <p>联系电话：</p>
                  <p>{{ orderInfo.cellPhone }}</p>
                </div>
              </div>

              <div class="main-bot">
                <div class="rig-item">
                  <p>付款方式：</p>
                  <p>{{ orderInfo.moneyType }}</p>
                </div>
                <div class="rig-item">
                  <p>支付时间：</p>
                  <p>{{ orderInfo.startTime }}</p>
                </div>
                <div class="rig-item">
                  <p>租期：</p>
                  <p>{{ orderInfo.time }}</p>
                </div>
                <div class="rig-item">
                  <p>租赁价：</p>
                  <p>{{ orderInfo.leasePrice }}</p>
                </div>
                <div class="rig-item">
                  <p>原价：</p>
                  <p>
                    {{ orderInfo.originalPprice }}
                  </p>
                </div>
                <div class="rig-item">
                  <p>优惠：</p>
                  <p>{{ orderInfo.fullIntegral }}</p>
                </div>
                <div class="rig-item">
                  <p>实付金额：</p>
                  <p class="color-blue">
                    {{ orderInfo.totalPrice }}环保值
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="view-item">
          <Nav label="商品列表"></Nav>
          <div class="table">
            <a-table
              :columns="columns"
              :data-source="tableData"
              :row-key="record => record.id"
              class="table-content"
              bordered
            >
              <template slot="mainPath" slot-scope="mainPath">
                <img :src="mainPath">
              </template>
            </a-table>
          </div>
        </div>
        <div
          v-if="orderInfo.state === '取消' || orderInfo.state === '退款中' || orderInfo.state === '退款完成' || orderInfo.state === '退款拒绝' || orderInfo.state === '卖家取消' || orderInfo.state === '买家取消' || orderInfo.state === '失效'"
          class="view-item"
        >
          <Nav label="退款详情"></Nav>
          <div class="table">
            <a-table
              :columns="columns2"
              :data-source="tableData2 "
              :row-key="record => record.id"
              class="table-content"
              bordered
            >
            </a-table>
          </div>
        </div>
        <div class="view-item">
          <Nav label="回收点信息"></Nav>
          <a-table
            :columns="columns1"
            :data-source="tableData1"
            :row-key="record => record.id"
            class="table-content"
            bordered
          >
            <template slot="storeImg" slot-scope="storeImg">
              <img :src="storeImg">
            </template>
          </a-table>
        </div>
        <div class="view-bottom">
          <a-button type="primary" small @click="goback">
            返回
          </a-button>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/nav'
import { getGoodsDetails } from '@/api/orderManage'
import { unixToDate } from '@/utils/formatDate'
const columns = [
  {
    title: '商品图片',
    key: 'mainPath',
    dataIndex: 'mainPath',
    scopedSlots: { customRender: 'mainPath' },
    align: 'center'
  },

  {
    title: '商品编号',
    key: 'goodsCode',
    dataIndex: 'goodsCode',
    align: 'center'
  },
  {
    title: '商品名称',
    key: 'introduce',
    dataIndex: 'introduce',
    align: 'center'
  },
  {
    title: '实付金额',
    key: 'bb',
    dataIndex: 'bb',
    align: 'center'
  },
  {
    title: '下单数量',
    key: 'tt',
    dataIndex: 'tt',
    customRender: () => 1,
    align: 'center'
  },
  {
    title: '可退数量',
    key: 'ee',
    dataIndex: 'ee',
    customRender: () => 1,
    align: 'center'
  }
]
const columns1 = [
  {
    title: '回收点图片',
    key: 'storeImg',
    dataIndex: 'storeImg',
    scopedSlots: { customRender: 'storeImg' },
    align: 'center'
  },

  {
    title: '回收点名称',
    key: 'name',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '详细地址',
    key: 'address',
    dataIndex: 'address',
    align: 'center'
  },
  {
    title: '站长',
    key: 'managerName',
    dataIndex: 'managerName',
    align: 'center'
  },
  {
    title: '联系电话',
    key: 'phone',
    dataIndex: 'phone',
    align: 'center'
  }
]
const columns2 = [
  {
    title: '退款单号',
    key: 'outRefundNo',
    dataIndex: 'outRefundNo',
    align: 'center'
  },

  {
    title: '商品编号',
    key: 'goodsCode',
    dataIndex: 'goodsCode',
    align: 'center'
  },
  {
    title: '商品名称',
    key: 'name',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '退款金额',
    key: 'refundFee',
    dataIndex: 'refundFee',
    align: 'center'
  },
  {
    title: '退款数量',
    key: 'num',
    dataIndex: 'num',
    customRender: () => 1,
    align: 'center'
  },
  {
    title: '返还配送费',
    key: 'a',
    dataIndex: 'a',
    align: 'center'
  },
  {
    title: '退款类型',
    key: 'state',
    dataIndex: 'state',
    align: 'center'
  },
  {
    title: '原因',
    key: 'b',
    dataIndex: 'b',
    align: 'center'
  }
]
export default {
  components: {
    Nav
  },
  data () {
    return {
      timeLineList: [],
      /**
       * 商品管理
       */
      columns,
      tableData: [],
      /**
       * 回收点管理
       */
      columns1,
      tableData1: [],
      /**
       * 退款详情
       */
      columns2,
      tableData2: [],
      loading: false,
      /**
       * 订单信息
       */
      orderInfo: {
        orderNo: '',
        state: '',
        createTime: '',
        channel: '',
        userName: '',
        cellPhone: '',
        moneyType: null,
        time: '',
        borrowIntegral: '',
        fullIntegral: '',
        totalPrice: ''
      }
    }
  },
  created () {
    this.getGoodsDetails()
  },
  methods: {
    // 获取详情数据
    async getGoodsDetails () {
      this.loading = true
      try {
        const res = await getGoodsDetails({ id: this.$route.query.id })
        if (res.code === 0) {
          res.result.orderDynamiclist.forEach((v, i) => {
            this.timeLineList.push({
              title: v.title,
              userName: v.userName ? `执行人：${v.userName}` : '',
              createTime: v.createTime ? `执行时间：${unixToDate(v.createTime)}` : ''
            })
          })
          this.orderInfo = res.result.orderDetails
          this.orderInfo.time = `${res.result.orderDetails.startTime} ~ ${res.result.orderDetails.endTime}`
          this.state(this.orderInfo.state)
          this.channel(this.orderInfo.channel)
          this.moneyType(this.orderInfo.moneyType)
          this.orderInfo.createTime = unixToDate(this.orderInfo.createTime)
          this.tableData.push(res.result.orderDetails)
          this.tableData1.push(res.result.orderDetails)
        }
      } finally {
        this.loading = false
      }
    },
    goback () {
      this.$router.replace('/catRecycling/OrderManagement/integralBorrowing')
    },
    state (text) {
      switch (text) {
        case 0:
          this.orderInfo.state = '待付款'
          break
        case 1:
          this.orderInfo.state = '付款完成'
          break
        case 2:
          this.orderInfo.state = '卖家入库'
          break
        case 4:
          this.orderInfo.state = '租赁中'
          break
        case 5:
          this.orderInfo.state = '超时'
          break
        case 6:
          this.orderInfo.state = '买家取货'
          break
        case 7:
          this.orderInfo.state = '完成'
          break
        case 8:
          this.orderInfo.state = '取消'
          break
        case 9:
          this.orderInfo.state = '退款中'
          break
        case 10:
          this.orderInfo.state = '退款完成'
          break
        case 11:
          this.orderInfo.state = '退款拒绝'
          break
        case 12:
          this.orderInfo.state = '卖家取消'
          break
        case 13:
          this.orderInfo.state = '买家取消'
          break
        case 14:
          this.orderInfo.state = '失效'
          break
        default:
          break
      }
    },
    channel (text) {
      switch (text) {
        case 0:
          this.orderInfo.channel = '小程序'
          break
        case 1:
          this.orderInfo.channel = 'app'
          break
        default:
          break
      }
    },
    moneyType (text) {
      switch (text) {
        case 0:
          this.orderInfo.moneyType = '碳积分'
          break
        case 1:
          this.orderInfo.moneyType = '余额'
          break
        default:
          break
      }
    }
  }
}

</script>
<style lang='less' scoped>
.integral-view{
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .ant-timeline-item{
    padding-bottom: 5px;
    p{
      margin-bottom: 5px;
    }
    // /deep/ .ant-timeline-item-tail{
    //   border-left-color: #1890ff;
    // }
  }
  .view-main{
    width: 100%;
    display: flex;
    flex-direction: column;

    .view-head{
      width: 100%;
      display: flex;
      .ant-steps-vertical{
        max-height: 40vh;
        overflow: auto;
      }
      /deep/ .ant-steps-item-icon{
        margin-left: 3px;
      }
      /deep/ .ant-steps-item-tail::after{
        margin-left: 15px;
      }
      /deep/ .ant-steps-item-process,/deep/ .ant-steps-item-wait {
        >.ant-steps-item-container > .ant-steps-item-tail::after {
          background: #aaa;
        }
      }
      /deep/ .ant-steps-item-title, /deep/ .ant-steps-item-content{
        width: 220px;
      }
      /deep/ .ant-steps-item-subtitle{
        display: block;
        margin-left: 0;
      }

      /* 设置滚动条的样式 */
      .ant-steps-vertical::-webkit-scrollbar {
        width:8px;
      }

      /* 滚动条滑块 */
      .ant-steps-vertical::-webkit-scrollbar-thumb {
        border-radius:10px;
        background:rgba(0,0,0,0.1);
      }

      .head-lef,.head-rig {
        border: 1px solid #eee;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .head-lef{
        flex: 1;
        min-width: 300px;
      }
      .head-rig{
        flex: 5;
        margin-left: 40px;
        display: flex;
        flex-direction: column;
        .rig-main{
          flex: 1;
          padding: 0 30px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          .main-top,.main-bot{
            display: grid;
            grid-template-columns: 1fr 1fr;
            justify-items: center;
            border-bottom: 1px solid #eee;

          }
          .main-bot{
            border: 0;
            margin-top: 20px;
          }
          .rig-item{
            width: 100%;
            display: flex;
            >p:nth-child(1) {
              width: 160px;
              min-width: 160px;
              text-align: right;
            }
            >p:nth-child(2) {
              margin-left: 20px;
            }
            .color{
              color: rgb(255, 153, 0);
            }
            .color-blue{
              color: rgb(0, 121, 254);
            }
          }
        }
      }
    }
  }
  .view-bottom{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  .view-item:nth-child(2){
    margin: 20px 0;
  }
  /deep/ .ant-table-pagination{
    display: none;
  }
  /deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td{
    padding: 0 !important;
  }
}
</style>

<style lang="stylus" scoped>
.dlMain
    width: 1
</style>
